<template>
  <div class="image-container">
    <img v-if="previewUrl" :src="previewUrl" class="img-fluid image" />
    <figure class="img-fluid image preview-icon" v-else>
      <i :class="previewIcon" />
    </figure>
    <base-button class="delete-button" @click="$emit('delete')">
      <i class="fas fa-times" style="color: white" />
    </base-button>
  </div>
</template>

<script>
import BaseButton from '@/components/base-button';

const FILE_TYPES = {
  IMAGE: 'image',
  DOCUMENT: 'document',
};

const ICON_TYPES = {
  [FILE_TYPES.IMAGE]: 'fa-file-image',
  [FILE_TYPES.DOCUMENT]: 'fa-file',
};

export default {
  name: 'BaseFile',
  components: {
    BaseButton,
  },
  props: {
    previewUrl: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      required: true,
      validator(value) {
        return Object.values(FILE_TYPES).includes(value);
      },
    },
    file: {
      required: true,
    },
  },
  computed: {
    previewIcon() {
      return `fas ${ICON_TYPES[this.type]}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.image-container {
  width: 60px !important;
  height: 60px;
  position: relative;
  flex-shrink: 0;
  margin-top: 10px;
}

.image {
  object-fit: cover;
  display: block;
  height: 100%;
  width: 100%;
}

.image-container:not(:nth-last-of-type(1)) {
  margin-right: 15px;
  margin-left: 10px;
}

.image-container:nth-last-of-type(1) {
  margin-left: 10px;
}
.delete-button {
  position: absolute;
  top: 0;
  left: 0;
  border: none;
  border-radius: 100%;
  width: 20px;
  height: 20px;
  padding: 0.6rem 0.6rem;
  background-color: #0088db;
  display: flex;
  justify-content: center;
  align-items: center;
  transform: translate(-50%, -40%);
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.8rem;

  &:hover {
    border: none;
  }
}

.preview-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid #c1c1c1;
  font-size: 2rem;
  color: #c1c1c1;
}
</style>
